import englishMessages from 'ra-language-english'

export const i18nEnglish = {
  ...englishMessages,
  submenu: {
    beheer: 'Admin',
    monitoring: 'Monitoring',
  },
  menu: {
    costExplorer: 'Cost Overview',
    applications: 'Applications',
    mcpServers: 'MCP Servers',
    proxies: 'Proxies',
    organizations: 'Organizations',
    automation: 'Automation',
    alerts: 'Alerts',
    auditLog: 'Audit logs',
    accessRequests: 'Access Requests',
    platformRequests: 'Platform Requests',
    requests: 'Requests',
    workflows: 'Workflows',
  },
  dashboard: {
    title: 'Dashboard',
    greeting: {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
    },
    description: 'Welcome to xxllnc.ai.',
    statistics: 'statistics',
    sectionPlatform: 'Platform',
    sectionTraffic: 'Traffic',
    totalServers: 'MCP Servers',
    totalProxies: 'Proxies',
    totalOrganizations: 'Organizations',
    totalUsers: 'Users',
    mcpLinks: 'MCP links',
    proxyLinks: 'Proxy links',
    activeUsers: 'Active users',
    totalCalls: 'total calls',
    mcpToday: 'MCP today',
    mcpWeek: 'MCP this week',
    proxyToday: 'Proxy today',
    proxyWeek: 'Proxy this week',
    requestsToday: 'Today',
    requestsThisWeek: 'This week',
    errorRate: 'Error rate',
    avgResponseTime: 'Response time',
    sectionOverall: 'Overall',
    activeAlerts: 'Active alerts',
    pendingAccessRequests: '%{count} pending access request(s) awaiting review',
    pendingPlatformRequests: '%{count} pending platform request(s) awaiting review',
    review: 'Review',
    topMcpOrganizations: 'Top organizations MCP (30 days)',
    topProxyOrganizations: 'Top organizations Proxy (30 days)',
    activeSeats: 'Active seats',
    topUsageOrgs: 'Top usage organizations (30 days)',
    activeWorkflows: 'Active workflows',
    recentExecutions: 'Executions (24h)',
    totalExecutions: 'total executions',
    popularMcps: 'Most popular MCPs',
    organizations: 'organizations',
    calls: 'calls',
    noData: 'No data available',
    live: {
      lastHour: 'Last hour',
      now: 'Now',
      last24h: 'Last 24h',
      calls: 'Calls',
      executions: 'Workflow runs',
      activeUsers: 'Active users',
      errorRate: 'Error rate',
      errors: 'Errors',
      trafficTitle: 'Traffic',
      durationsTitle: 'Workflow durations',
      avg: 'avg',
      noRuns: 'No runs in this window',
      workflow: 'Workflow',
      runs: 'Runs',
      errorsCol: 'Errors',
      mcpErrorsTitle: 'MCP servers with errors (recent)',
      workflowErrorsTitle: 'Workflows with errors (recent)',
      weeklyArchive: 'Traffic per week',
    },
    capacity: {
      title: 'Capacity',
      mcp: 'MCP traffic',
      workflows: 'Workflows',
      healthy: 'Comfortable',
      busy: 'Busy',
      atLimit: 'At limit',
      noPeak: 'no recent peak',
      noDataTooltip: 'No recent data to estimate capacity yet.',
      headerTooltip:
        'Estimated platform load over the last 7 days. Capacity is computed for ' +
        '%{pods} pods with an average workflow duration of %{seconds} seconds.',
      mcpTooltip:
        'Peak per hour: %{peak} requests (%{peakAt}). Average %{avg} per hour. ' +
        'Capacity: %{ceiling} per hour. The platform can spin up extra pods as load increases.',
      workflowTooltip:
        'Peak per hour: %{peak} executions (%{peakAt}). Average %{avg} per hour. ' +
        'Capacity: %{ceiling} per hour on %{pods} pods with an average duration of %{seconds}s.',
    },
  },
  resources: {
    application: {
      list: 'Applications',
      create: 'Create application',
      show: 'Application',
      edit: 'Edit application',
      tabs: {
        environments: 'Environments',
        headers: 'Headers',
      },
    },
    // eslint-disable-next-line camelcase
    application_environment: {
      name: 'Environment',
    },
    // eslint-disable-next-line camelcase
    mcp_server: {
      name: 'MCP Server |||| MCP Servers',
      tabs: {
        details: 'Details',
        tools: 'Tools',
        links: 'Links',
        logs: 'Logs',
        skills: 'Skills',
      },
    },
    proxy: {
      tabs: {
        setup: 'Setup',
        details: 'Details',
        tools: 'Tools',
        links: 'Links',
        logs: 'Logs',
      },
    },
    // eslint-disable-next-line camelcase
    mcp_tool: {
      create: 'Create tool',
      edit: 'Edit tool',
    },
    // eslint-disable-next-line camelcase
    proxy_tool: {
      create: 'Create tool',
      edit: 'Edit tool',
    },
    organization: {
      tabs: {
        details: 'Details',
        users: 'Users',
        links: 'Links',
        mcpLinks: 'MCP Links',
        proxyLinks: 'Proxy Links',
        workflowLinks: 'Workflow Links',
        usage: 'Usage',
        automations: 'Automations',
        chatConfig: 'Chat Config',
        identityProviders: 'Identity Providers',
        logs: 'Logs',
      },
      idp: {
        title: 'SSO Connections',
        add: 'Add SSO',
        addTitle: 'Add Identity Provider',
        added: 'Identity provider added',
        addFailed: 'Could not add the identity provider. Please check the details and try again.',
        loadFailed: 'Could not load SSO connections. The identity provider may be unavailable.',
        providerType: 'Provider Type',
        alias: 'Alias',
        displayName: 'Display Name',
        empty: 'No SSO connections configured.',
        notProvisioned: 'This organization is not yet provisioned in the identity provider. Sync organizations first.',
      },
    },
    // eslint-disable-next-line camelcase
    organization_user: {
      create: 'Create user',
      edit: 'Edit user',
    },
    // eslint-disable-next-line camelcase
    organization_mcp_link: {
      create: 'Create MCP link',
      edit: 'Edit MCP link',
    },
    // eslint-disable-next-line camelcase
    organization_proxy_link: {
      create: 'Create Proxy link',
      edit: 'Edit Proxy link',
    },
    // eslint-disable-next-line camelcase
    organization_workflow_link: {
      create: 'Add workflow link',
      edit: 'Edit workflow link',
      linkLabel: '%{org} → %{workflow}',
      costPerWorkflowExecution: 'Cost per execution (EUR, override)',
      costPerWorkflowExecutionHelp:
        'Override the per-run fee for this organisation’s use of this workflow. '
        + 'Leave empty to inherit the workflow or portal default.',
      variablesTitle: 'Variable values',
      variablesSubtitle:
        'Values this organisation supplies for the variables the workflow references via '
        + '{{ variables.X }}. Leave empty to fall back to nothing at runtime.',
      variablesEmpty:
        'This workflow does not reference any variables. '
        + 'Variables appear here once a node parameter uses {{ variables.<name> }}.',
      variableHelper: 'Per-organisation value',
      serverConfigsTitle: 'Server configuration',
      serverConfigsSubtitle:
        'Per required MCP server, pick which environment, base URL and seat this organisation '
        + 'uses when the workflow runs.',
      serverConfigsEmpty:
        'This workflow has no MCP tool steps that need per-organisation server configuration.',
      environment: 'Environment',
      environmentNone: 'Use server default',
      baseUrl: 'Target URL',
      seat: 'Seat (identity)',
      seatNone: 'Use caller identity',
      seatHelper:
        'Scheduled (cron) runs act as this seat, because they have no triggering user. '
        + 'Manual runs act as the user who starts them and MCP runs pass through the caller — '
        + 'leave empty for those.',
    },
    // eslint-disable-next-line camelcase
    monitoring_rule: {
      name: 'Rule',
      tabs: {
        details: 'Details',
        alerts: 'Alerts',
      },
    },
    // eslint-disable-next-line camelcase
    monitoring_alert: {
      list: 'Alerts',
      show: 'Alert',
    },
    documentUploads: {
      list: 'Document uploads',
      show: 'Document upload',
      upload: {
        button: 'Upload document',
        title: 'Upload document',
        success: 'Document upload created',
      },
      tabs: {
        details: 'Details',
        logs: 'Logs',
      },
    },
  },
  auditLog: {
    timestamp: 'Timestamp',
    action: 'Action',
    actor: 'Actor',
    actorUserId: 'Actor user ID',
    targetType: 'Target type',
    targetId: 'Target ID',
    context: 'Details',
    createdAfter: 'From',
    createdBefore: 'Until',
  },
  data: {
    costThisMonth: 'Cost this month',
    usage: 'Usage',
    seats: 'Seats',
    mcpCostThisMonth: 'MCP cost',
    proxyCostThisMonth: 'Proxy cost',
    callsThisMonth: 'Calls this month',
    monthlyCosts: 'Monthly costs',
    currentMonth: 'Current',
    noCostData: 'No cost data available.',
    details: 'Details',
    name: 'Name',
    description: 'Description',
    createdAt: 'Created at',
    lastModified: 'Last modified',
    displayName: 'Display name',
    baseUrl: 'Base URL',
    baseUrlHelp: 'Leave empty to use the server default URL.',
    authType: 'Auth type',
    headerName: 'Header name',
    headerValue: 'Header value',
    headerType: 'Type',
    headerSource: 'Source',
    headerPrefix: 'Prefix',
    headerPrefixHelp: 'Prepended to the value, e.g. "employee:"',
    headerCustomValue: 'Value',
    headerCreated: 'Header created',
    headerUpdated: 'Header updated',
    customHeadersOptional: 'Custom HTTP headers (optional)',
    customHeadersDescription: 'Custom HTTP headers sent with requests to this application.',
    costPer1000Calls: 'Cost per 1000 calls (€)',
    valueTypeCustom: 'Custom',
    valueTypeOrganization: 'Organization',
    valueTypeUser: 'User',
    orgMetadataHelp: 'org.name, org.auth_id, or org.metadata.<key>',
    headerValueSource: 'Value / Source',
    addHeader: 'Add',
    editHeader: 'Edit header',
    addHeaderTitle: 'Add header',
    noHeaders: 'No headers configured.',
    deleteHeaderConfirm: 'Are you sure you want to delete this header?',
    headerEnvironments: 'Environments',
    headerEnvironmentsHelp: 'Select which environments this header applies to. Leave empty for all.',
    tokenParamsDescription: 'Extra parameters sent in the OAuth token request body.',
    addTokenParam: 'Add',
    addTokenParamTitle: 'Add token parameter',
    editTokenParam: 'Edit token parameter',
    noTokenParams: 'No token parameters configured.',
    deleteTokenParamConfirm: 'Are you sure you want to delete this token parameter?',
    tokenParamCreated: 'Token parameter created',
    tokenParamUpdated: 'Token parameter updated',
    tokenParamName: 'Parameter name',
    allEnvironments: 'All',
    userInterface: 'User interface',
    token: 'Token',
    enabled: 'Enabled',
    serverId: 'Server ID',
    httpMethod: 'HTTP Method',
    path: 'Path',
    parameters: 'Parameters',
    paramName: 'Parameter name',
    paramType: 'Type',
    required: 'Required',
    username: 'Username',
    auth0Email: 'Auth0 email address',
    organizationId: 'Organization ID',
    mcpServer: 'MCP Server',
    userAccess: 'User access',
    connectUrl: 'Connect URL',
    users: 'Users',
    selectUser: 'Select user',
    grantAccess: 'Activate',
    revokeAccess: 'Revoke',
    seatUsersEmpty: 'No seats found in this organization',
    colUser: 'User',
    colAccess: 'Access',
    toolSource: 'Tool source',
    toolSourceManual: 'Manual',
    toolSourceOpenapi: 'OpenAPI Sync',
    toolSourceOdata: 'OData Sync',
    odataUrl: 'OData Metadata URL',
    odataUrlHelp: 'URL to the $metadata endpoint (e.g. https://api.example.com/odata/$metadata)',
    openapiUrl: 'OpenAPI JSON URL',
    openapiUrlHelp: 'URL to the OpenAPI JSON spec file',
    openapiSource: 'OpenAPI source',
    specUrl: 'Spec URL',
    specInputUrl: 'URL',
    specInputFile: 'Upload file',
    selectSpecFile: 'Select spec file',
    uploadSpecFile: 'Upload new spec file',
    syncTools: 'Sync',
    syncFailed: 'Sync failed',
    copied: 'Copied',
    copy: 'Copy',
    copyUrl: 'Copy URL',
    organization: 'Organization',
    toolName: 'Tool',
    success: 'Success',
    searchLogs: 'Search logs...',
    searchTools: 'Search tools...',
    copyFailed: 'Copy failed. Please copy manually.',
    enableAll: 'Enable all',
    disableAll: 'Disable all',
    proxy: 'Proxy',
    targetUrl: 'Target URL',
    proxyId: 'Proxy ID',
    auth0OrgId: 'Auth0 Organization ID',
    searchAuth0User: 'Search Auth0 user...',
    searchAuth0Org: 'Search Auth0 organization...',
    typeToSearch: 'Type to search...',
    noResults: 'No results',
    application: 'Application',
    applicationType: 'Application',
    noApplicationType: 'No application',
    interface: 'Interface',
    certificate: 'Certificate',
    downloadCert: 'Download certificate',
    downloadKey: 'Download private key',
    generateCert: 'Generate certificate',
    regenerateCert: 'Regenerate certificate',
    ruleType: 'Type',
    logSource: 'Source',
    aggregation: 'Aggregation',
    operator: 'Operator',
    threshold: 'Threshold',
    windowMinutes: 'Time Window (minutes)',
    cooldownMinutes: 'Cooldown (minutes)',
    lastTriggered: 'Last Triggered',
    severity: 'Severity',
    acknowledged: 'Acknowledged',
    condition: 'Condition',
    actions: 'Actions',
    ruleTypeCustom: 'Custom',
    ruleTypeFairUse: 'Fair Use',
    logSourceAll: 'All',
    logSourceMcp: 'MCP',
    logSourceProxy: 'Proxy',
    allOrganizations: 'All organizations',
    acknowledge: 'Acknowledge',
    title: 'Title',
    status: 'Status',
    statusAvailable: 'Available',
    statusInactive: 'Inactive',
    blockedUntil: 'Blocked until %{date}',
    mcpCalls: 'MCP calls',
    proxyCalls: 'Proxy calls',
    workflowExecutions: 'Workflow executions',
    statMcpServers: 'MCP Servers',
    statProxies: 'Proxies',
    statHeaders: 'Headers',
    statTools: 'Tools',
    statLinks: 'Links',
    statSkills: 'Skills',
    statusExpired: 'Expired',
    statusDownloaded: 'Downloaded',
    singleUse: 'Single use',
    downloaded: 'Downloaded',
    expiresAt: 'Expires at',
    created: 'Created',
    createdBy: 'Created by',
    visibility: 'Visibility',
    visibilityPersonal: 'Personal',
    visibilityShared: 'Shared',
    authTypeNone: 'None',
    authTypeOauthClientCredentials: 'OAuth client credentials',
    authTypeClientCertificate: 'Client certificate',
    authTypeCustomHeaders: 'Custom Headers',
    authTypePassword: 'Password',
    authTypeAuth0: 'Auth0',
    auth0User: 'Auth0 user',
    password: 'Password',
    expiration: 'Expiration',
    expiration1Day: '1 day',
    expiration7Days: '7 days',
    expiration30Days: '30 days',
    expirationNever: 'Never',
    selectFiles: 'Select files',
    files: 'Files',
    downloadLogs: 'Download logs',
    downloaderIdentity: 'Downloader',
    errorMessage: 'Error message',
    ipAddress: 'IP address',
    addSource: 'Add API Source',
    addSourceName: 'Name',
    addSourceType: 'Type',
    addSourceSpecUrl: 'Spec URL',
    addSourceSpecUrlHelp: 'URL to the OpenAPI JSON/YAML or OData $metadata',
    addSourceSubmit: 'Add',
    addSourceSuccess: 'API source added and synchronized',
    sourceDeleted: 'API source deleted',
    syncResult: 'Sync: %{created} new, %{updated} updated, %{disabled} disabled',
    manualTools: 'Manual tools',
    noToolsFound: 'No tools found',
    noTools: 'No tools',
    hideDisabled: '%{count} disabled',
    modified: 'Modified',
    deleteSource: 'Delete',
    other: 'Other',
    logLevel: 'Log level',
    testFailed: 'Test failed',
    sync: 'Sync',
    orgSyncResult: 'Sync completed: %{created} created, %{updated} updated, %{deleted} deleted, %{reactivated} reactivated',
    metadataFields: 'Custom metadata fields',
    metadataKey: 'Key',
    metadataValue: 'Value',
    deletedBanner: 'This organization has been deleted from Auth0. No new links or users can be added.',
    marketplaceVisible: 'Visible in marketplace',
    mcpUrlSlug: 'URL slug',
    mcpUrlSlugHelp: 'The URL path used for this MCP (e.g. /mcp/my_server). Changing this will break existing connections.',
    mcpAbout: 'About this MCP (portal)',
    projectInstructions: 'Project instructions (CLAUDE.md / GEMINI.md)',
    projectInstructionsHelp: 'Instructions that users copy to their project configuration',
    advancedSettings: 'Advanced Settings',
    isDemo: 'Demo MCP',
    isDemoHelp:
      'Demo MCPs can be activated in the portal without approval and are automatically linked to new free-tier organisations.',
    defaultBaseUrl: 'Default target URL',
    defaultBaseUrlHelp: 'Used as base URL when creating organisation links. Required for Demo MCPs.',
    defaultEnvironment: 'Default environment',
    defaultEnvironmentHelp: 'Environment used for auto-approve. Required when auto-approve is enabled.',
    autoApproveAccess: 'Auto-approve access requests',
    skillLinked: 'Skill linked',
    skillUnlinked: 'Skill unlinked',
    skillUpdated: 'Skill updated',
    skillCreatedLinked: 'Skill created and linked',
    skillEdit: 'Edit',
    skillUnlink: 'Unlink',
    skillLinkExisting: 'Link existing skill',
    skillAdd: 'Add',
    skillNew: 'New skill',
    skillsShared: 'Skills are shared across MCP servers. Changes to a skill apply everywhere it is linked.',
    skillsEmpty: 'No skills linked yet. Link an existing skill or create a new one.',
    skillsAllLinked: 'All skills are already linked to this server.',
    skillsAllLinkedForApp: 'All skills for this application are linked. Remove the filter to see other skills.',
    skillFilterAllApps: 'All applications',
    skillLinkedTo: 'Linked to %{count} servers',
    skillDialogEdit: 'Edit skill',
    skillDialogNew: 'New skill',
    skillApplication: 'Application',
    skillNoApplication: 'No application (global)',
    skillName: 'Name',
    skillDescription: 'Description (optional)',
    skillContent: 'Content',
    skillCancel: 'Cancel',
    skillSave: 'Save',
    skillCreate: 'Create',
    skillClose: 'Close',
    skillCustom: 'Custom',
    tokenUrl: 'Token URL',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    audience: 'Audience',
    certificatePem: 'Client Certificate (PEM)',
    certificatePemHelp: 'PEM-encoded client certificate',
    privateKeyPem: 'Private Key (PEM)',
    privateKeyPemHelp: 'PEM-encoded private key (unencrypted)',
    environment: 'Environment',
    environments: 'Environments',
    addEnvironment: 'Add environment',
    editEnvironment: 'Edit environment',
    deleteEnvironmentConfirm: 'Are you sure you want to delete this environment?',
    noEnvironments: 'No environments configured.',
    environmentAuthHelp: 'Auth credentials are configured per environment.',
    environmentCreated: 'Environment created',
    environmentUpdated: 'Environment updated',
    envStatusActive: 'Active',
    envStatusDisabled: 'Disabled',
    noEnvironmentsHint: 'Add an environment to configure authentication credentials.',
    identitySection: 'Identity',
    authenticationSection: 'Authentication',
    toolEdit: 'Edit tool',
    toolUpdated: 'Tool updated',
    toolSaveFailed: 'Save failed',
    toolEnabled: 'Enabled',
    toolDisabled: 'Disabled',
    toolParameters: 'Parameters',
    toolParameter: 'Parameter',
    toolEnum: 'Enum:',
    workflows: 'Workflows',
    mcpHealth: 'MCP Health',
    healthy: 'Healthy',
    warning: 'Warning',
    error: 'Error',
    noRecentWorkflows: 'No recent workflow executions',
    noMcpLinks: 'No MCP links',
    downloadUrl: 'Download URL',
    severityCritical: 'Critical',
    severityWarning: 'Warning',
    severityInfo: 'Info',
    workflow: 'Workflow',
    triggeredBy: 'Triggered by',
    triggerType: 'Trigger type',
  },
  costExplorer: {
    title: 'Cost Overview',
    totalCosts: 'Total costs',
    seatCosts: 'Seat costs',
    mcpSlotCosts: 'MCP slot costs',
    workflowSlotCosts: 'Workflow slot costs',
    workflowExecutionCosts: 'Workflow execution costs',
    platformCosts: 'Platform costs',
    chatCosts: 'Chat costs',
    periodCurrentMonth: 'This month',
    period3m: '3 months',
    period6m: '6 months',
    period12m: '12 months',
    periodAll: 'All time',
    organization: 'Organization',
    allOrganizations: 'All organizations',
    costTimeline: 'Cost timeline',
    organizationBreakdown: 'Organization breakdown',
    seats: 'Seats',
    mcpSlots: 'MCP slots',
    workflowSlots: 'Workflow slots',
    total: 'Total',
    calls: 'Calls',
    cost: 'Cost',
    serverBreakdown: 'Cost per MCP server',
    proxyBreakdown: 'Cost per proxy',
    workflowBreakdown: 'Cost per workflow',
    workflow: 'Workflow',
    proxy: 'Proxy',
    executions: 'Executions',
    executionCost: 'Execution cost',
    aiTokens: 'AI tokens',
    aiCostEstimated: 'AI cost (est.)',
    avgPerDay: 'Avg per day',
    vsLastPeriod: 'vs last period',
  },
  usageChart: {
    daily: 'Daily',
    monthly: 'Monthly',
    noData: 'No usage data available',
    loadError: 'Failed to load usage data',
  },
  logsChart: {
    total: 'Total',
    errors: 'Errors',
    period24h: '24 hours',
    period7d: '7 days',
    period30d: '30 days',
  },
  delete: {
    confirmTitle: 'Confirm deletion',
    confirmContentMcp:
      'Are you sure you want to delete this MCP server? All linked ' +
      'organization connections, user access and logs will also be deleted.',
    confirmContentProxy:
      'Are you sure you want to delete this proxy? All linked organization ' +
      'connections, user access and logs will also be deleted.',
    confirmContentOrganization:
      'Are you sure you want to delete this organization? All users, ' +
      'connections and logs will also be deleted.',
    confirmContentDocument:
      'Are you sure you want to delete this document upload? All files and ' +
      'download logs will also be deleted.',
    confirmContentUser: 'Are you sure you want to delete this user?',
    confirmContentMcpLink:
      'Are you sure you want to delete this MCP link? ' +
      'All user access will also be deleted.',
    confirmContentProxyLink: 'Are you sure you want to delete this proxy link?',
    confirmContentMonitoringRule: 'Are you sure you want to delete this monitoring rule? All associated alerts will also be deleted.',
    confirmContentWorkflow:
      'Are you sure you want to delete this workflow? All linked ' +
      'organization connections and executions will also be deleted.',
  },
  proxySetup: {
    title: 'Proxy configuration',
    intro: 'Follow these steps to configure this proxy for API access.',
    step1Title: 'Proxy Base URL',
    step1Description:
      'Use this base URL followed by the target API path. ' +
      'Authenticate with a client certificate (mTLS). Download the certificate and private key from the organization link.',
    step2Title: 'Test the connection',
    step2Description:
      'Use the curl command below to test the proxy. Replace ' +
      '{path-to-api} with the desired API path. Use the client certificate and private key from the organization link.',
    curlComment: '# Test the proxy connection with client certificate',
  },
  settings: {
    title: 'Settings',
    description: 'Manage your personal preferences',
    saved: 'Settings saved',
    organization: 'Organization',
    organizationName: 'Name',
    organizationAuthId: 'Organization ID',
    section: {
      language: 'Language',
      appearance: 'Appearance',
      about: 'About',
    },
    languageTitle: 'Language',
    languageDescription: 'Choose the interface language',
    appearanceTitle: 'Appearance',
    appearanceDescription: 'Customize the application appearance',
    filtersOpen: 'Filters open by default',
    filtersOpenHelp: 'Automatically show the filter panel on list pages',
    rowsPerPage: 'Rows per page',
    aboutTitle: 'About this application',
    userName: 'Name',
    userEmail: 'Email',
    appVersion: 'Version',
  },
  login: {
    title: 'Admin',
    button: 'Continue',
    email: 'name@work-email.com',
    emailLabel: 'Email address',
    emailHint: 'Log in to continue.',
    hint: 'Log in to xxllnc.ai',
    notValid: 'The email address is not valid',
    byXxllnc: 'xxllnc.ai is an application by xxllnc',
    inactive: 'You have been logged out due to inactivity.',
    selectOrganization: 'Select your organization',
    noOrganization: 'No organization found for this email domain.',
    back: 'Back',
    loading: 'Looking up organizations...',
    lookingFor: 'Looking for the xxllnc.ai user login?',
    signInToHub: 'Sign in to xxllnc.ai for your organisation',
    changeRegion: 'Change region',
    noAdminAccess: 'No admin access',
    noAdminAccessHint:
      'Your account is signed in, but does not have access to the admin dashboard. ' +
      'Sign out to try a different account, or continue to the MCP Hub.',
    noAdminAccessAction: 'Sign out and use another account',
  },
  page: {
    unauthorized: {
      headerTitle: 'Unauthorized',
      defaultTitle: 'Unauthorized',
      title: 'You are not authorized to perform this action.',
      text: 'You tried to perform an action you do not have permission for.',
    },
    noPermissions: {
      title: 'No permissions assigned',
      text:
        'Your account has dashboard access but no fine-grained permissions. '
        + 'Ask a platform admin to assign the sa.* roles (or the admin_full '
        + 'composite) you need.',
    },
  },
  orgMembers: {
    noAuth0Org: 'This organization has no Auth0 org linked.',
    noMembers: 'No members found in Auth0 for this organization.',
    name: 'Name',
    email: 'Email',
    roles: 'Roles',
    seat: 'Seat',
    chat: 'Chat',
    seatYes: 'Active',
    seatNo: 'No seat',
    chatOn: 'Enabled',
    chatOff: 'Disabled',
    beheerder: 'Beheerder',
    assignSeat: 'Assign seat',
    removeSeat: 'Remove seat',
    makeBeheerder: 'Make beheerder',
    removeBeheerder: 'Remove beheerder',
    seatAssigned: 'Seat assigned successfully',
    seatRemoved: 'Seat removed successfully',
    beheerderAssigned: 'Beheerder role assigned successfully',
    beheerderRemoved: 'Beheerder role removed successfully',
    installInChat: 'Install in Chat',
    removeFromChat: 'Remove from Chat',
    chatInstalled: 'User installed in Chat successfully',
    chatRemoved: 'User removed from Chat successfully',
    actionFailed: 'Action failed. Please try again.',
  },
  portalBranding: {
    title: 'Styling',
    menuTitle: 'Styling',
    description: 'Configure the styling of the portals. Colors, logo and titles are shown to all users.',
    noConfig: 'No branding configuration yet. Save to create.',
    saved: 'Settings saved',
    section: {
      colors: 'Colors',
      header: 'Header',
      typography: 'Typography & Shape',
      secureAccessBranding: 'xxllnc.ai branding',
      mcpHubBranding: 'MCP Hub branding',
    },
    primaryColor: 'Primary color',
    primaryColorHelp: 'Main color for buttons and accents, e.g. #28282C',
    secondaryColor: 'Secondary color',
    secondaryColorHelp: 'Accent color, e.g. #E86E44',
    loginBgColor: 'Login background color',
    loginBgColorHelp: 'Background of the login page',
    bgColor: 'Page background',
    bgColorHelp: 'Background of the portal (default: #fafafa)',
    headerColor: 'Header background color',
    headerColorHelp: 'Default: white',
    headerTextColor: 'Header text color',
    headerTextColorHelp: 'Use a light color (#ffffff) for dark headers',
    fontFamily: 'Font',
    fontFamilyHelp: 'Google Fonts name, e.g. Inter or Roboto. Empty = DM Sans',
    borderRadius: 'Corner rounding (0-20)',
    borderRadiusHelp: '0 = sharp/corporate, 10 = default, 20 = rounded',
    adminTitle: 'Admin portal title',
    adminTitleHelp: 'Title shown in the xxllnc.ai admin portal header',
    portalTitle: 'Portal title',
    portalTitleHelp: 'E.g. MCP Hub',
    loginSubtitle: 'Login page subtitle',
    loginSubtitleHelp: 'Short welcome text on the login page (max 200 chars)',
    logoUrl: 'Logo',
    logoUrlHelp: 'URL to the logo (image)',
    faviconUrl: 'Favicon',
    faviconUrlHelp: 'URL to the favicon',
    uploadImage: 'Upload image',
    changeImage: 'Change image',
    enabled: 'Custom branding active',
  },
  portalSettings: {
    title: 'Portal Settings',
    menuTitle: 'Portal Settings',
    description: 'Configure platform settings, tier limits, features and portal branding.',
    saved: 'Settings saved',
    section: {
      branding: 'Branding',
      tiers: 'Tier Limits',
      features: 'Features',
      defaults: 'Cost Defaults',
      chat: 'Chat',
      importExport: 'Import / Export',
    },
    chat: {
      description:
        'Enable or disable individual chat models. Enabled models are usable by '
        + 'every chat user; disabled models are admin-only.',
      enabled: 'Enabled',
      disabled: 'Disabled',
      enabledCount: '{count} of {total} models enabled',
      loadFailed: 'Could not load models.',
      updateFailed: 'Could not update the model. Please try again.',
      retry: 'Retry',
      empty: 'No chat models are available yet.',
    },
    branding: {
      description: 'Configure the styling of the MCP Hub portal. Colors, logo and titles are shown to all portal users.',
    },
    importExport: {
      description: 'Bundle and migrate platform configuration. Sensitive credentials are never included.',
      export: {
        title: 'Export configuration',
        description: 'Create a transferable JSON bundle of applications, MCP servers and workflows.',
        button: 'Export configuration…',
        modalTitle: 'Export configuration',
        modalIntro: 'Choose what to include. Dependencies are added automatically '
          + '— an MCP server brings its application, a workflow brings its servers and applications.',
        applications: 'Applications',
        mcpServers: 'MCP servers',
        workflows: 'Workflows',
        modeNone: 'None',
        modeAll: 'All',
        modeSelected: 'Choose…',
        includeDependencies: 'Include dependencies automatically',
        downloadButton: 'Download bundle',
        cancel: 'Cancel',
        emptySelection: 'Select at least one item to export.',
      },
      import: {
        title: 'Import configuration',
        description: 'Apply a previously exported bundle to this instance.',
        dropzone: 'Drop a .json bundle here or click to browse',
        dropzoneActive: 'Release to load bundle',
        invalidFile: 'Only .json bundles are supported.',
        previewTitle: 'Review import',
        previewIntro: 'Review what will be created, updated or skipped before applying.',
        sectionApplications: 'Applications',
        sectionSkills: 'Skills',
        sectionMcpServers: 'MCP servers',
        sectionWorkflows: 'Workflows',
        chipNew: 'New',
        chipExists: 'Exists',
        toggleAll: 'Toggle all',
        decisionCreate: 'Create',
        decisionSkip: 'Skip',
        decisionOverwrite: 'Overwrite',
        dependsOn: 'Requires %{names}',
        warningHeader: 'Warnings',
        executeButton: 'Import (%{count})',
        cancel: 'Cancel',
        successCounts: '%{created} created · %{updated} updated · %{skipped} skipped · %{failed} failed',
        emptyBundle: 'This bundle contains no items.',
        previewing: 'Reading bundle…',
      },
      lastImport: {
        title: 'Last import',
        description: 'Most recent import that was applied to this instance.',
        emptyState: 'No import has been recorded yet.',
        by: 'by %{actor}',
        bundle: 'Bundle: %{filename}',
        statCreated: 'created',
        statUpdated: 'updated',
        statSkipped: 'skipped',
        statFailed: 'failed',
      },
    },
    tiers: {
      description: 'Configure MCP slots and seat limits per tier. These limits apply platform-wide.',
      mcpSlots: 'MCP slots',
      seatMax: 'Max seats',
      approval: 'Approval',
      autoApprove: 'Auto-approve free tier for new organisations',
    },
    features: {
      description: 'Enable or disable platform features globally.',
      chatEnabled: 'Chat (Open WebUI) enabled',
      authTitle: 'Authentication',
      beheerderRole: 'Beheerder role',
      beheerderRoleHelp: 'Select the Keycloak realm role that identifies portal administrators.',
      selectScope: 'Select the required scope for beheerder access:',
    },
    defaults: {
      description: 'Default cost values for new organisations. Can be overridden per organisation.',
      costPerSeat: 'Cost per seat',
      costPerMcp: 'Cost per MCP slot',
      costPerWorkflow: 'Cost per workflow slot',
      costPerWorkflowExecution: 'Cost per workflow execution',
      costPerWorkflowExecutionHelp:
        'Charged for every workflow run when neither the workflow nor an org-workflow link '
        + 'sets its own rate.',
      aiQuotaEurPerHour: 'AI hourly limit',
      aiQuotaEurPerHourHelp:
        'Hard hourly cap on AI spend inside workflows when an organisation has no override.',
      platformBudget: 'Platform budget',
      workflowBudget: 'Workflow budget',
      chatBudget: 'Chat budget',
    },
    litellm: {
      title: 'LiteLLM spend import',
      description:
        'One management-scoped LiteLLM API key used to import AI spend for all organisations '
        + 'every ~10 minutes. Each org is matched on its stored LiteLLM key id.',
      status: 'Status:',
      configured: 'Configured',
      notConfigured: 'Not configured',
      keyLabel: 'Management API key',
      keyHelp:
        'Paste a management-scoped key to set or replace it. Leave empty to keep the current key.',
    },
    capacity: {
      title: 'Platform capacity',
      description:
        'Ceilings used by the capacity widget and the automatic alert rules. ' +
        'Adjust when you add pods or change the average workflow duration.',
      mcpHourCeiling: 'MCP capacity per hour',
      mcpHourCeilingHelp:
        'Maximum MCP requests per hour with a fully warm cache and current pod configuration.',
      workflowPods: 'Number of pods',
      workflowPodsHelp:
        'Number of active secureaccess-api pods (Helm maxReplicas). Together with average duration this drives the workflow ceiling.',
      avgWorkflowSeconds: 'Average workflow duration (seconds)',
      avgWorkflowSecondsHelp:
        'Expected average duration per workflow execution. Ceiling = pods × 50 slots × 3600 ÷ duration.',
      alertThresholdPct: 'Alert threshold (%)',
      alertThresholdPctHelp:
        'Fires a notification once the peak load crosses this percentage of capacity.',
    },
  },
  platformRequest: {
    filters: {
      status: 'Status',
      tier: 'Tier',
    },
    status: {
      pending: 'Pending',
      approved: 'Approved',
      denied: 'Denied',
    },
    tier: {
      free: 'Free',
      team: 'Team',
      enterprise: 'Enterprise',
    },
    fields: {
      organization: 'Organization',
      tier: 'Tier',
      requester: 'Requester',
      status: 'Status',
      date: 'Date',
      actions: 'Actions',
    },
    approve: 'Approve',
    deny: 'Deny',
    denyDialog: {
      title: 'Deny request',
      reason: 'Reason',
      cancel: 'Cancel',
    },
  },
  automationRule: {
    scope: 'Scope',
    scopeGlobal: 'All organizations',
    scopeSpecific: 'Specific organizations',
    tiers: 'Tiers',
    organizations: 'Organizations',
    triggers: 'Triggers',
    actions: 'Actions',
    loading: 'Loading...',
    tabs: {
      details: 'Details',
      alerts: 'Alerts',
    },
    test: 'Test',
    titleCreate: 'New automation',
    titleEdit: 'Edit automation',
    created: 'Rule created',
    updated: 'Rule updated',
    saveFailed: 'Save failed',
    tierFilter: 'Tier filter',
    validation: {
      nameRequired: 'Name is required',
      triggerRequired: 'Add at least 1 trigger',
      actionRequired: 'Add at least 1 action',
    },
    flow: {
      when: 'WHEN',
      then: 'THEN',
      done: 'DONE',
      addTrigger: 'Add trigger',
      addAction: 'Add action',
      triggerChip: 'TRIGGER',
      actionChip: 'ACTION',
    },
    settings: {
      label: 'SETTINGS',
      subtitle: 'Scope, cooldown & status',
      cooldownHelp: 'Minimum time between two activations (0 = no limit)',
    },
    picker: {
      configuration: 'Configuration',
      addToFlow: 'Add to flow',
      triggerHint: 'When should this rule activate?',
      actionHint: 'What should happen?',
    },
  },
  accessRequest: {
    search: 'Search',
    status: {
      pending: 'Pending',
      approved: 'Approved',
      denied: 'Denied',
    },
    requestType: {
      organization: 'Organization',
      user: 'User',
    },
    fields: {
      requester: 'Requester',
      mcpServer: 'MCP Server',
      organization: 'Organization',
      type: 'Type',
      environment: 'Environment',
      status: 'Status',
      date: 'Date',
      actions: 'Actions',
      environmentUrl: 'Environment URL',
      environmentName: 'Environment',
      message: 'Message',
    },
    approve: 'Approve',
    createLink: 'Create link',
    deny: 'Deny',
    denyDialog: {
      title: 'Deny request',
      reason: 'Reason',
      cancel: 'Cancel',
    },
    noExtraInfo: 'No additional information for this request.',
  },
  openwebuiConfig: {
    sectionLitellm: 'LiteLLM',
    sectionLitellmHelp: 'LLM gateway: API key and key metadata used to route chat traffic.',
    sectionOpenwebui: 'Open WebUI',
    sectionOpenwebuiHelp: 'The chat interface: instance URL and admin API key for user management.',
    litellmApiKey: 'LiteLLM API Key',
    litellmApiKeyHelp: 'E.g. sk-zOUVjchU...',
    keyName: 'Key name',
    keyNameHelp: 'Readable name of the key in LiteLLM',
    keyId: 'Key ID',
    keyIdHelp: 'Internal key hash/ID from LiteLLM',
    openwebuiUrl: 'Open WebUI URL',
    openwebuiUrlHelp: 'Public URL of the Open WebUI instance for this organization',
    openwebuiApiKey: 'Open WebUI API Key',
    openwebuiApiKeyHelp: 'Admin API key for managing users in Open WebUI',
    enabled: 'Active',
    enabledTierHelp: 'Only available on the Enterprise (production) tier.',
    tierWarning: 'Chat can only be activated for organizations on the Enterprise (production) tier. '
      + 'Change the tier to Enterprise to enable chat.',
    descriptionExisting: 'Chat configuration for this organization.',
    descriptionNew: 'No chat configuration yet. Save to create one.',
  },
  organizationCosts: {
    costPerSeat: 'Cost per seat (EUR/month)',
    costPerSeatHelp: 'Leave empty for default (EUR 15.00)',
    costPerMcp: 'Cost per MCP (EUR/month)',
    costPerMcpHelp: 'Leave empty for default (EUR 25.00)',
    costPerWorkflow: 'Cost per workflow (EUR/month)',
    costPerWorkflowHelp: 'Leave empty for portal default',
    aiQuotaEurPerHour: 'AI budget per hour (EUR)',
    aiQuotaEurPerHourHelp: 'Hard cap on AI spend per hour for this organization. Leave empty for portal default.',
  },
  logs: {
    time: 'Time',
    noLogs: 'No logs found',
    statusOk: 'OK',
    statusError: 'Error',
    bodyPreview: 'Response body preview',
    detailStatus: 'Status',
    detailUrl: 'URL',
    detailResponseTime: 'Response time',
    detailError: 'Error',
  },
  requests: {
    mcpRequest: 'MCP access',
    workflowRequest: 'Workflow',
    workflowGenerationRequest: 'AI workflow',
    platformRequest: 'Platform',
    aiPrompt: 'Prompt',
    aiSummary: 'AI summary',
    openInGenerator: 'Open in generator',
    noRequests: 'No pending requests',
    filterAll: 'All',
    filterPending: 'Pending',
    filterApproved: 'Approved',
    filterDenied: 'Denied',
    environmentUrl: 'Environment URL',
    reviewedBy: 'Reviewed by',
    reviewNote: 'Review note',
    requestedTier: 'Requested tier',
    description: {
      mcp: 'MCP: %{server}',
      platform: 'Tier upgrade: %{tier}',
    },
  },
  filters: {
    title: 'Filters',
    show: 'Show filters',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    deleted: 'Deleted',
    marketplace: 'Marketplace',
    marketplaceVisible: 'Visible',
    marketplaceHidden: 'Not visible',
    toolSource: 'Tool source',
    application: 'Application',
    authType: 'Auth type',
    tier: 'Tier',
    tierFree: 'Free',
    tierTeam: 'Team',
    tierEnterprise: 'Enterprise',
    tierNone: 'None',
    scope: 'Scope',
  },
  mcp: {
    list: {
      cost: 'Cost / 1k calls',
      costPer1k: '/ 1k',
      links: 'Links',
      requests24h: 'Last 24h',
    },
  },
  workflow: {
    title: 'Workflow Editor',
    untitled: 'Untitled Workflow',
    loading: 'Loading...',
    create: {
      nameDialogTitle: 'Name your workflow',
      nameLabel: 'Display name',
    },
    variables: {
      title: 'Variables',
      subtitle: 'Auto-detected from {{ variables.X }} references in your workflow nodes.',
      emptyHelp: 'No variables yet — reference one with {{ variables.<name> }} in any node parameter and it will appear here.',
    },
    costPerWorkflowExecution: 'Cost per execution (EUR)',
    costPerWorkflowExecutionHelp: 'Override per-run fee for this workflow. Leave empty to inherit from organization or portal default.',
    sidebar: {
      search: 'Search nodes...',
      triggers: 'Triggers',
      mcpTools: 'MCP Tools',
      logic: 'Logic',
      data: 'Data',
      ai: 'AI',
    },
    nodes: {
      trigger: 'Trigger',
      toolCall: 'MCP Tool Call',
      aiCall: 'AI Call',
      aiCallDesc: 'Call an LLM model',
      condition: 'Condition',
      loop: 'Loop',
      transform: 'Transform',
      fieldMapping: 'Field mapping',
      fieldMappingDesc: 'Declarative field-by-field mapping with transforms',
      merge: 'Merge',
      cron: 'Cron Schedule',
      webhook: 'Webhook',
      manual: 'Manual Start',
      mcpTrigger: 'MCP Tool',
      cronDesc: 'Recurring schedule',
      webhookDesc: 'HTTP callback',
      manualDesc: 'Run manually',
      mcpTriggerDesc: 'Exposed as MCP tool for AI clients',
      conditionDesc: 'If/else branch',
      loopDesc: 'Iterate over items',
      mergeDesc: 'Wait for branches',
      transformDesc: 'Map & transform data',
      visualization: 'Visualization',
      visualizationDesc: 'Render data as table or chart',
      data: 'Data source',
      dataDesc: 'Read a slice from a link attachment (XML/JSON)',
      parse: 'Parse',
      parseDesc: 'Run a registered parser (e.g. iNavigator → Zaken payload)',
      mcp: 'MCP Tool',
      dataStoreWrite: 'Data store: write',
      dataStoreWriteDesc: 'Store a value (vector or plain) under an identifier for later lookup',
      dataStoreRead: 'Data store: read',
      dataStoreReadDesc: 'Read a value back from the data store (semantic or by key)',
      dataStoreUpdate: 'Data store: update',
      dataStoreUpdateDesc: 'Replace content + metadata of an existing vector record by id',
      dataStoreDelete: 'Data store: delete',
      dataStoreDeleteDesc: 'Remove a vector record by id (idempotent)',
      dataStore: 'Data store',
      // eslint-disable-next-line max-len
      dataStoreDesc: 'Read, write, update or delete entries in the semantic data store (pick the operation in the node config).',
      tested: 'Tested',
    },
    config: {
      title: 'Node Configuration',
      fm: {
        inputSource: 'Input source',
        inputSourceHelp: 'Path like "nodes.data-1" or "trigger" — the dict to map from.',
        mappings: 'Mappings',
        addMapping: 'Add mapping',
        noMappings: 'No mappings yet — add one to extract fields.',
        from: 'From',
        to: 'To',
        transform: 'Transform',
        required: 'Required',
        maxLength: 'Max length',
        defaultValue: 'Default value',
        lookupTable: 'Lookup table (JSON)',
        lookupTableHelp: 'Map source values to target values, e.g. {"Jaar":"year","Maand":"month"}.',
        regexPattern: 'Regex pattern',
        regexReplacement: 'Replacement',
        transformNone: 'No transform',
        transformUppercase: 'UPPERCASE',
        transformLowercase: 'lowercase',
        transformTrim: 'Trim whitespace',
        transformTruncate: 'Truncate',
        transformDefault: 'Default if empty',
        transformLookup: 'Lookup table',
        transformToNumber: 'To number',
        transformToBoolean: 'To boolean',
        transformRegexReplace: 'Regex replace',
      },
      label: 'Label',
      server: 'MCP Server',
      tool: 'Tool',
      parameters: 'Parameters',
      expression: 'Expression',
      assertTruthy: 'Fail the workflow when this condition is false',
      assertTruthyHelp: 'When enabled, a false result stops the workflow and returns the error message below to the MCP caller.',
      assertError: 'Error message',
      assertErrorPlaceholder: 'e.g. No person found with this name',
      cronExpression: 'Cron expression',
      webhookPath: 'Webhook path',
      attachmentRole: 'Attachment role',
      attachmentRoleHelp: 'Unique name such as source_xml',
      attachmentRoleRequired: 'This data-node is not runnable until it has an attachment role.',
      attachmentLabel: 'Attachment label',
      attachmentLabelHelp: 'What the customer sees when uploading, e.g. i-Navigator DSP export',
      attachmentDescription: 'Attachment description',
      attachmentDescriptionHelp: 'Optional guidance shown next to the upload field',
      attachmentFormatHint: 'Attachment format hint',
      attachmentFormatHintHelp: 'MIME or format hint, e.g. application/xml',
      format: 'Format',
      selector: 'Selector',
      selectorHelp: 'XPath (XML) or dotted path (JSON). Supports {{ expressions }}.',
      sourceExpression: 'Source expression',
      // eslint-disable-next-line max-len
      sourceExpressionHelp: 'What to render. Leave empty for the full output of the previous node, or point at a slice, e.g. {{ nodes.get-casetype.output.data }}.',
      // eslint-disable-next-line max-len
      mcpHelp: 'Workflows with an MCP trigger are exposed as tools on /api/v1/mcp/workflows. Add this URL as an MCP server in Claude Desktop.',
      arrayExpression: 'Array expression',
      itemVariable: 'Item variable',
      loopLogChildren: 'Log each body node per iteration',
      // eslint-disable-next-line max-len
      loopLogChildrenHelp: 'When on, every node inside the loop body is recorded as its own execution step. Default off so a large loop (e.g. CSV import) does not flood the steps view. Turn on for small gating loops where you want full visibility.',
      trueLabel: 'True',
      falseLabel: 'False',
      perItem: 'Per item',
      mergeStrategy: 'Merge strategy',
      waitAll: 'Wait for all',
      firstResult: 'First result',
      deleteNode: 'Delete node',
      fieldMapping: 'Field mapping',
      paramJsonHelp: 'Send this parameter as JSON (object, array, boolean or number) instead of text',
      paramJsonInvalid: 'Invalid JSON — the value is not saved until it parses',
      paramJsonFormat: 'Format JSON',
      paramNoDescription: 'No description — type: %{type}',
      paramSourceFixed: 'Fixed',
      paramSourceExpression: 'Expression',
      insertExpressionHelp: 'Insert an expression — reference data from the trigger or previous nodes',
      optionalFields: 'Optional fields (%{smart_count})',
      // eslint-disable-next-line max-len
      paramsRemoved: '%{smart_count} parameter removed — it is not supported by the selected tool. |||| %{smart_count} parameters removed — they are not supported by the selected tool.',
      toolEmptyState: 'Choose an MCP server and a tool to configure this step.',
      toolDisabledSuffix: 'disabled',
      // eslint-disable-next-line max-len
      toolDisabledWarning: 'The selected tool is disabled on the MCP server. Enable it on the server or pick another tool — this step will fail as long as the tool is disabled.',
      // eslint-disable-next-line max-len
      inputDataEmpty: 'No input data known yet. Run a successful test on a previous node to see its fields here.',
      inputDataHint: 'Click a field to insert it into the last-selected parameter field.',
      inputDataFromTrigger: 'trigger input',
      inputDataFromTest: 'from test result',
      inputDataFromAi: 'from expected output',
      inputDataInserted: 'Inserted',
      inputDataCopied: 'Copied — click a parameter field first to insert directly',
      outputExample: 'Expected JSON output (example)',
      // eslint-disable-next-line max-len
      outputExampleHint: 'Example of the JSON object the AI must return. Appended behind the prompt as a structure hint; its keys become available to later nodes as {{ nodes.<id>.output.field }}.',
      paramsNotInSchema: 'Not in tool schema',
      paramsNotInSchemaHint: 'Saved on the node and sent on every run, but not declared by the tool. Edit or remove them.',
      paramNotInSchemaType: 'saved',
      paramRemove: 'Remove parameter',
      paramRequired: 'Required parameter',
      testCall: 'Test call',
      aiModel: 'Model',
      systemPrompt: 'System prompt',
      systemPromptPlaceholder: 'You are a helpful assistant...',
      userPrompt: 'User prompt',
      userPromptPlaceholder: 'Use {{ expressions }} to reference data from previous nodes',
      inputData: 'Input data',
      expectJson: 'Expect JSON output',
      temperature: 'Temperature',
      parser: 'Parser',
      parserPlaceholder: 'Pick a registered parser...',
      parserNoneEnabled: 'No parsers are enabled in this deploy. Set ENABLED_PARSERS in the API config.',
      parserMode: 'Mode',
      parserModeParse: 'Parse',
      parserModeRequirements: 'Requirements (dry-run)',
      parserInputSource: 'Input source',
      // eslint-disable-next-line max-len
      parserInputSourceHelp: 'Path expression resolved against context. Usually points at the upstream data node, e.g. {{ inavigator_xml.match }}.',
      parserExtra: 'Extra inputs',
      // eslint-disable-next-line max-len
      parserExtraHelp: 'Resolved per-call and passed to the parser. Use this to inject UUIDs from earlier tool_calls (e.g. catalog_folder_uuid).',
      parserExtraKeyPlaceholder: 'extra key, e.g. catalog_folder_uuid',
      mcpToolName: 'MCP tool name',
      mcpToolNameHelp: 'Lowercase, snake_case. This is what Claude Desktop will call.',
      mcpToolDescription: 'MCP tool description',
      // eslint-disable-next-line max-len
      mcpToolDescriptionPlaceholder: 'What does this tool do? When should the assistant use it?',
      mcpToolDescriptionHelp: 'Shown to the assistant in tools/list. Be specific.',
      mcpToolInputSchema: 'Input schema',
      // eslint-disable-next-line max-len
      mcpToolInputSchemaHelp: 'JSON Schema describing the arguments the tool accepts. Validated on blur.',
      mcpSchemaModeFields: 'Fields',
      mcpSchemaFieldName: 'name',
      mcpSchemaFieldType: 'type',
      mcpSchemaNoFields: 'No fields yet — click "+ Add field" to define one.',
      mcpSchemaAddField: 'Add field',
      mcpSchemaRequired: 'required',
      mcpSchemaFieldDescription: 'Description (shown to the calling AI)',
      mcpSchemaMinLength: 'minLength',
      mcpSchemaMaxLength: 'maxLength',
      mcpSchemaFormat: 'format',
      mcpSchemaMin: 'min',
      mcpSchemaMax: 'max',
      mcpSchemaMinItems: 'minItems',
      mcpSchemaMaxItems: 'maxItems',
      mcpSchemaArrayItems: 'Array item schema',
      mcpSchemaJsonNotAnObject: 'Top-level schema must be a JSON object — got a different type.',
      mcpSchemaNameCollision: 'A field with this name already exists.',
      mcpSchemaNameEmpty: 'Field name cannot be empty.',
      dataStoreMode: 'Storage mode',
      dataStoreModeVector: 'Vector (semantic)',
      dataStoreModePlain: 'Plain (key/value)',
      // eslint-disable-next-line max-len
      dataStoreModeVectorHelp: 'Stores in pgvector and embeds the content on save. Read returns the closest matches by meaning.',
      // eslint-disable-next-line max-len
      dataStoreModePlainHelp: 'Stores in Redis as identifier+key → value. No embedding cost, exact-match read.',
      // eslint-disable-next-line max-len
      dataStoreReadVectorHelp: 'Semantic search over previously stored content. Slower; returns the closest matches by meaning.',
      // eslint-disable-next-line max-len
      dataStoreReadPlainHelp: 'Exact lookup by key. Leave the key empty to return every entry under the identifier.',
      dataStoreIdentifier: 'Identifier',
      // eslint-disable-next-line max-len
      dataStoreIdentifierHelp: 'Collection name. Workflows sharing the same identifier share the same data slice (scoped per organization).',
      dataStoreKey: 'Key',
      dataStoreKeyHelp: 'Required for plain mode. Becomes the Redis hash field name.',
      dataStoreReadKeyHelp: 'Key to look up. Leave empty to return every entry stored under this identifier.',
      dataStoreKeyword: 'Keyword filter',
      // eslint-disable-next-line max-len
      dataStoreKeywordHelp: 'Optional substring match on content, key and metadata values. Bind to an MCP arg (e.g. {{ trigger.keyword }}) to let the assistant search the collection.',
      // eslint-disable-next-line max-len
      csvHelp: 'CSV is parsed into a list of rows. Use a Loop node downstream (arrayExpression: nodes.<id>.rows) and reference columns via {{ item.<header> }}.',
      autocompleteFunctionsLoadFailed:
        'Built-in functions list failed to load. Refresh the editor — auth may have expired.',
      dataStoreOperation: 'Operation',
      dataStoreOpRead: 'Read',
      dataStoreOpWrite: 'Write',
      dataStoreOpUpdate: 'Update',
      dataStoreOpDelete: 'Delete',
      dataStoreContent: 'Content to store',
      dataStoreValue: 'Value to store',
      dataStoreRecordId: 'Record id',
      // eslint-disable-next-line max-len
      dataStoreRecordIdHelp: 'UUID of the record to update or delete. Usually bound to {{ trigger.id }} when called as an MCP tool.',
      // eslint-disable-next-line max-len
      dataStoreContentHelp: 'Free text or {{ nodes.x.output }} reference. Embedded automatically on save.',
      // eslint-disable-next-line max-len
      dataStoreValueHelp: 'Free text or {{ nodes.x.output }} reference. Stored verbatim in Redis.',
      dataStoreMetadata: 'Metadata (optional)',
      dataStoreMetadataHelp: 'Key/value pairs preserved on the record. Each value can reference upstream nodes.',
      dataStoreQuery: 'Search query',
      // eslint-disable-next-line max-len
      dataStoreQueryHelp: 'Natural-language question. The closest matching records (cosine similarity) are returned in hits[].',
      dataStoreTopK: 'Top K hits',
      dataStoreTopKHelp: 'How many records to return (1–50). Lower is faster.',
    },
    node: {
      missingAttachmentRoleSubtitle: 'Missing attachment role',
      missingAttachmentRoleWarning: 'Configure an attachment role before saving this workflow.',
      dataStoreMissingIdentifier: 'Missing identifier',
      dataStoreMissingContent: 'Missing content',
      dataStoreMissingKey: 'Missing key',
      dataStoreMissingQuery: 'Missing query',
      dataStoreMissingRecordId: 'Missing record id',
      dataStoreUpdateSummary: 'Updates record',
      dataStoreDeleteSummary: 'Deletes record',
      dataStoreDeletePlainSummary: 'Delete (plain) from',
      dataStoreWriteVectorSummary: 'Stores (vector) into',
      dataStoreWritePlainSummary: 'Stores (plain) into',
      dataStoreReadVectorSummary: 'Searches (vector) in',
      dataStoreReadPlainSummary: 'Reads (plain) from',
      dataStoreReadAll: 'all entries',
    },
    actions: {
      autoLayout: 'Auto layout',
      undo: 'Undo',
      executions: 'Executions',
      editFlow: 'Edit flow',
    },
    details: {
      name: 'Name',
      about: 'About',
      triggerType: 'Trigger type',
      nodeCount: 'Nodes',
      edgeCount: 'Edges',
      autoApprove: 'Auto-approve',
    },
    list: {
      cost: 'Cost / run',
      costPortalDefault: '(portal default)',
      costNotSet: 'Not set',
      links: 'Links',
      executions24h: 'Last 24h',
      triggerType: 'Trigger',
    },
    stat: {
      executions24h: 'Runs · last 24h',
      executionsTotal: 'Runs · total',
      executionsSuccessful: 'Successful runs',
      executionsFailed: 'Failed runs',
      links: 'Links',
      successRate: 'Success rate',
      successRateNoData: 'Success rate (no data)',
      successRateTitle: 'Health',
    },
    filters: {
      trigger: 'Trigger',
      triggerManual: 'Manual',
      triggerCron: 'Cron',
      triggerWebhook: 'Webhook',
      triggerMcp: 'MCP tool',
    },
    tabs: {
      details: 'Details',
      links: 'Links',
      executions: 'Executions',
      noExecutions: 'No executions yet.',
    },
    test: {
      title: 'Test',
      organization: 'Organization',
      seat: 'User (optional)',
      noSeat: 'Default (admin)',
      environment: 'Environment',
      defaultEnvironment: 'Default',
      execute: 'Execute',
      success: 'Success',
      failed: 'Failed',
      availableFields: 'Available fields (click to copy path)',
      copied: 'Copied!',
      orgHelp: 'Determines which organization\'s connection and data the test uses.',
      // eslint-disable-next-line max-len
      seededFromExpression: 'In the workflow this is filled by %{expression} — enter a concrete test value.',
      invalidJson: 'Invalid JSON',
      omitValue: 'Leave out',
      errorAuth: 'Not authorized — check the connection (authentication) for this organization.',
      errorForbidden: 'Access denied — this user or connection is not allowed to perform this action.',
      errorNotFound: 'Not found — the resource or endpoint does not exist in the target system.',
      errorValidation: 'The parameters do not match what the tool expects — check required fields and types.',
      errorUpstream: 'The upstream server returned an error — try again or check the target system.',
      errorNetwork: 'Could not reach the upstream server — check the base URL and connectivity.',
      errorDetails: 'Details',
    },
    execution: {
      workflow: 'Workflow',
      organization: 'Organization',
      status: 'Status',
      trigger: 'Trigger',
      triggeredBy: 'Triggered by',
      started: 'Started',
      finished: 'Finished',
      duration: 'Duration',
      stepsCount: 'Steps',
      steps: 'Steps',
      error: 'Error',
      filterStatus: 'Status',
      completed: 'Completed',
      running: 'Running',
      failed: 'Failed',
      pending: 'Pending',
      success: 'Success',
      skipped: 'Skipped',
      deleteTitle: 'Delete execution?',
      deleteContent: 'This execution record and all its steps will be permanently deleted.',
    },
    ai: {
      button: 'Generate with AI',
      title: 'AI workflow generator',
      intro:
        'Describe what your workflow should do — including the trigger, the steps, and where the output goes.'
        + ' The assistant will ask follow-up questions if anything is unclear.',
      descriptionLabel: 'Describe the workflow',
      descriptionPlaceholder:
        'Every weekday at 9:00 fetch the open Topdesk tickets, summarise them with an LLM,'
        + ' and post the summary in #service-desk on Slack.',
      submit: 'Continue',
      analyzing: 'Analysing your description…',
      needsMoreInfo: 'I need a bit more information',
      answerLabel: 'Add the missing details',
      answerPlaceholder: 'Provide the missing information…',
      summaryTitle: 'Here is what I will build',
      summaryHint: 'Confirm the description below or adjust it before building.',
      build: 'Build workflow',
      edit: 'Adjust description',
      building: 'Building your workflow…',
      successTitle: 'Workflow ready',
      successMessage: 'Open the workflow to review and refine it.',
      openWorkflow: 'Open workflow',
      errorTitle: 'Something went wrong',
      errorBody: 'The assistant could not generate this workflow.',
      retry: 'Try again',
    },
    doctor: {
      title: 'AI Doctor',
      intro:
        'This run failed. Let the AI inspect the trace and suggest a concrete fix you can apply.',
      start: 'Diagnose',
      analyzing: 'Analysing the failure…',
      cached: '(cached)',
      explanation: 'Explanation',
      suggestedFix: 'Suggested fix',
      suggestedInputs: 'Suggested input',
      rootCause: 'Root cause',
      refresh: 'Fresh diagnosis',
      retryWithFix: 'Retry with fix',
      retryStarted: 'Retry started.',
    },
    copilot: {
      title: 'AI Co-pilot',
      tagline: 'Edit this workflow with AI',
      toggle: 'AI Co-pilot',
      intro:
        'Describe what you want to change. The Co-pilot proposes a diff you can preview before applying.',
      try: 'Try a prompt',
      suggestRetry: 'Add a retry to the failing tool call',
      suggestSummary: 'Insert an AI step that summarises the previous output',
      suggestParallel: 'Run the two tool calls in parallel and merge the result',
      placeholder: 'Describe a change…',
      send: 'Send',
      thinking: 'AI is thinking…',
      you: 'You',
      assistant: 'Co-pilot',
      pendingDiff: 'Proposed change',
      apply: 'Apply',
      discard: 'Discard',
      diffAdd: 'Add',
      diffUpdate: 'Update',
      diffRemove: 'Remove',
    },
    editor: {
      unsavedTitle: 'Unsaved changes',
      // eslint-disable-next-line max-len
      unsavedBody: 'You have unsaved changes in this workflow. If you leave this page they will be lost.',
      unsavedStay: 'Keep editing',
      unsavedLeave: 'Leave without saving',
    },
    validation: {
      title: 'This workflow has issues',
      description: 'Fix the issues below before saving, or use "Save anyway" if you know what you are doing.',
      errorCount: '%{count} error |||| %{count} errors',
      warningCount: '%{count} warning |||| %{count} warnings',
      cancel: 'Fix issues',
      saveAnyway: 'Save anyway',
      saveAnywayConfirm: 'Saving will keep the unresolved references. They will resolve to an empty string at runtime. Continue?',
      jumpToNode: 'Jump to node',
      registryUnavailable: 'Could not verify function names — the functions registry is unavailable.',
      unclosedBraces: 'Unclosed expression — add `}}` to close `{{`.',
      emptyExpression: 'Empty expression — write something between `{{` and `}}`.',
      emptySegment: 'Empty path segment — remove the extra dot.',
      unknownRoot: 'Unknown root `%{root}` — use `functions`, `variables`, `trigger`, or `nodes`.',
      unknownFunction: 'Unknown function `functions.%{name}` — check the spelling.',
      malformedFunctionCall: 'Function call needs parentheses — write `functions.<name>(...)`.',
      unknownNode: 'No node named `%{id}` in this workflow.',
      nodeNotReachable: 'Node `%{id}` is not a predecessor of this node — it will resolve to an empty string at runtime.',
      unknownTriggerKey: 'Trigger has no field `%{key}`.',
      unknownVariable: 'Variable `%{name}` is not referenced elsewhere yet — it will be created on save.',
    },
  },
}
